import { Realty, services } from '@ambita/ambita-components-core';

const { filters } = services;

const createShortCadastreAddress = function (addressIdent: Realty.AddressIdent): string {
  return `${filters.padLeft(addressIdent.municipalityNumber, 4, '0')}/` +
    `${addressIdent.cadastralUnitNumber}/` +
    `${addressIdent.unitNumber}/` +
    `${addressIdent.leaseholdUnitNumber}/` +
    `${addressIdent.subNumber}`;
};

const createPostalLocation = function (address: Realty.ApiAddress): string {
  if (!address) {
    return '';
  }

  const { postalCode, postalPlace } = address.street || address.postalPlace;

  return `${filters.padLeft(postalCode, 4, '0')} ${postalPlace}`;
};

const createCadastreAddress = function (address: Realty.ApiAddress): string {
  return `${createShortCadastreAddress(address.ident)}, ${createPostalLocation(address)}`;
};

const createShortStreetAddress = function (address: Realty.ApiAddress): string {
  let shortStreetAddress = '';

  if (address.street && address.street.streetName) {
    shortStreetAddress += address.street.streetName;
  }

  if (address.ident && address.ident.addressNumber) {
    shortStreetAddress += ` ${address.ident.addressNumber}`;
  }

  if (address.ident && address.ident.letter) {
    shortStreetAddress += address.ident.letter;
  }

  return shortStreetAddress;
};

const createStreetNumber = function (addressIdent: Realty.AddressIdent): string {
  return addressIdent && addressIdent.streetNumber ? `, gatenr ${addressIdent.streetNumber}` : '';
};

const createStreetAddress = function (address: Realty.ApiAddress, addStreetNumber = false): string {
  let streetAddress: string = createShortStreetAddress(address);

  if (addStreetNumber) {
    streetAddress += createStreetNumber(address.ident);
  }

  if (streetAddress && streetAddress.trim().length > 0) {
    streetAddress += ', ';
  }

  streetAddress += createPostalLocation(address);

  return streetAddress;
};

const createLongStreetAddress = function (address: Realty.ApiAddress): string {
  return createStreetAddress(address, true);
};

const mapAddress = function (address: Realty.ApiAddress): any {
  const transformedAddress: any = {};

  if (!address) {
    return transformedAddress;
  }

  transformedAddress.municipality =
    `${address.municipality.municipalityName} ${address.municipality.municipalityNumber}`;

  if (address.key) {
    transformedAddress.addressKey = address.key;
  }

  if (address.street && address.street.streetName) {
    transformedAddress.streetName = address.street.streetName;
  }

  if (address.ident.letter) {
    transformedAddress.letter = address.ident.letter;
  }

  if (address.ident.addressNumber) {
    transformedAddress.addressNumber = address.ident.addressNumber;
  }

  if (address.sourceOfAddressName) {
    transformedAddress.sourceOfAddressName = address.sourceOfAddressName;
  }

  if (address.alternativeAddress) {
    transformedAddress.alternativeAddress = address.alternativeAddress;
  }

  if (address.ident.hasOwnProperty('cadastralUnitNumber')) {
    transformedAddress.cadastralUnitNumber = address.ident.cadastralUnitNumber;
  }

  if (address.ident.hasOwnProperty('leaseholdUnitNumber')) {
    transformedAddress.leaseholdUnitNumber = address.ident.leaseholdUnitNumber;
  }

  if (address.ident.hasOwnProperty('subNumber')) {
    transformedAddress.subNumber = address.ident.subNumber;
  }

  if (address.ident.hasOwnProperty('unitNumber')) {
    transformedAddress.unitNumber = address.ident.unitNumber;
  }

  if (address.ident.municipalityNumber) {
    transformedAddress.municipalityNumber = address.ident.municipalityNumber;
  }

  if (address.updatedDate) {
    transformedAddress.updatedDate = address.updatedDate.ddmmyyyy;
  }

  if (address.addressType && address.addressType.code === 'M') {
    transformedAddress.cadastreAddress = createCadastreAddress(address);
    transformedAddress.shortCadastreAddress = createShortCadastreAddress(address.ident);
  } else {
    transformedAddress.streetAddress = createStreetAddress(address);
    transformedAddress.shortStreetAddress = createShortStreetAddress(address);
    transformedAddress.longStreetAddress = createLongStreetAddress(address);
  }

  transformedAddress.postalCode = address.street ? address.street.postalCode : address.postalPlace.postalCode;
  transformedAddress.postalPlace = address.street ? address.street.postalPlace : address.postalPlace.postalPlace;
  transformedAddress.postalLocation = createPostalLocation(address);

  if (address.position && address.position.geometry && address.position.geometry.coordinates) {
    transformedAddress.coordinates = address.position.geometry.coordinates;
  }

  transformedAddress.links = address.links;

  return transformedAddress;
};

const transformAddresses = function (addressesData: Realty.ApiResponse): any {
  let addresses: Realty.ApiAddress[] = [];

  if (addressesData.item) {
    addresses = [addressesData.item];
  }

  if (addressesData.items) {
    addresses = addressesData.items;
  }

  return {
    addresses: addresses.map(mapAddress)
  };
};

export default transformAddresses;
